// extracted by mini-css-extract-plugin
export default {"noteActions":"NoteActions_noteActions__2SbMK","deleteDialog__root":"NoteActions_deleteDialog__root__Py8Vp"};